import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'

const ConnectionDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<h3>인증서 본인확인 서비스 이용약관</h3>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default ConnectionDetail